import React from "react";
import {Modal} from "antd";

export class ChoiceHotSheetCreate extends React.Component {
  render() {
    return (
      <Modal title="Create Hot Sheet" centered visible={this.props.visible} onOk={() => this.props.setModelVisible(false)} onCancel={() => this.props.setModelVisible()} width="55%" className="cat-modal wrk-odr-mdl">
        <button className="cat-btn" type="primary" onClick={() => this.props.importQuote()}>Import from Existing Quote</button>
        <button className="cat-btn" type="primary" onClick={() => this.props.addNewHotSheet()}>Create New</button>
      </Modal>
    )
  }
}


// WEBPACK FOOTER //
// ./src/pages/tracks/hotsheet/popups/ChoiceHotSheetCreate.jsx